export default {
  KEEP_LIVING: "keep_living",
  SELL: "sell",
  SOLD: "sold",
};
